export { IconModule } from './icon.module';
